import request from '../utils/request';
import { IResult } from '../global';

const voteApi = {
  one: (id: string | number, force?: boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url:
          '/api/v2/luck/getone?id=' +
          id +
          '&_with=goodsDetail' +
          (force ? `&_t=${Date.now()}` : ''),
        method: 'get'
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  lucktome: (luck_id: string | number) => {
    // /api/v2/luck/:luck_id/opportunity
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/luck/${luck_id}/opportunity`,
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  luckresult: (luck_id: string | number, page: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/luckrecord/${luck_id}/list`,
        data: {
          page
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  myresult: (page: number, luckId?: number | string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/luckrecord/self/list`,
        headers: {
          Authorization: request.token
        },
        data: {
          page,
          luck_id: luckId
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  addRecord: (luck_id: string | number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/luck/${luck_id}/join`,
        method: 'post',
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },

  verify: (record_id: string | number, update: any) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/luck/verif/${record_id}`,
        method: 'post',
        headers: {
          Authorization: request.token
        },
        data: update
      })
        .then(resolve)
        .catch(reject);
    });
  }
};

export default voteApi;
